<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="print:hidden rounded-3xl mr-0 shadow-[0_4px_18px_rgba(0,0,0,0.04)] app-background"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
  [opened]="!isScreenSmall"
  (openedChanged)="isNavigationOpened = $event">
  <!-- Navigation header -->
  <ng-container fuseVerticalNavigationHeader>
    <div class="flex items-center w-full p-4 pl-6 pt-6">
      <div class="flex items-center justify-center shrink-0">
        <img class="w-auto h-4 object-contain dark:hidden" src="assets/images/logo/drivr-black.png" alt="Logo" />
        <img class="w-auto h-4 object-contain hidden dark:block" src="assets/images/logo/drivr-white.png" alt="Logo" />
      </div>

      <div class="flex items-center ml-auto">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Navigation footer (user) -->
  <ng-container fuseVerticalNavigationFooter>
    <div class="flex items-center w-full p-6 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      [matMenuTriggerFor]="profileMenu">
      <div class="relative w-10 h-10 mr-3">
        <img class="w-full h-full rounded-full shadow-sm" *ngIf="user.avatar"
          [ngSrc]="appSettingService.getFilePath(user.avatar)" alt="User avatar" />

        <mat-icon *ngIf="!user.avatar" class="icon-size-10 text-gray-400"
          svgIcon="heroicons_solid:user-circle"></mat-icon>
      </div>

      <div class="min-w-0 shrink flex-auto">
        <div class="text-sm font-semibold text-gray-800 dark:text-gray-100 truncate">
          {{ user.name }}
        </div>
        <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
          {{ user.email }}
          <!-- Display email like the screenshot -->
        </div>
      </div>

      <mat-icon class="icon-size-5 text-gray-400 ml-2" svgIcon="heroicons_outline:ellipsis-vertical"></mat-icon>
    </div>

    <mat-menu [xPosition]="'before'" [yPosition]="'above'" #profileMenu="matMenu">
      <!-- Header User Info inside Menu -->
      <div class="flex items-center px-4 py-3">
        <div class="relative w-10 h-10 mr-3 shrink-0">
          <img class="w-full h-full rounded-full shadow-sm" *ngIf="user.avatar"
            [ngSrc]="appSettingService.getFilePath(user.avatar)" alt="User avatar" />

          <mat-icon *ngIf="!user.avatar" class="icon-size-10 text-gray-400"
            svgIcon="heroicons_solid:user-circle"></mat-icon>
        </div>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-semibold truncate">{{ user.name }}</span>
          <span class="text-sm text-secondary truncate">{{ user.email }}</span>
        </div>
      </div>

      <mat-divider class="my-1"></mat-divider>

      <button mat-menu-item [routerLink]="['/profile/settings']">
        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span>Account</span>
      </button>

      <mat-divider class="my-1"></mat-divider>

      <button mat-menu-item [matMenuTriggerFor]="appearanceMenu">
        <mat-icon [svgIcon]="'heroicons_outline:sun'"></mat-icon>
        <span>Appearance</span>
      </button>

      <mat-divider class="my-1"></mat-divider>

      <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
      </button>
    </mat-menu>

    <mat-menu #appearanceMenu="matMenu">
      <button mat-menu-item (click)="setScheme('light')">
        <mat-icon [svgIcon]="'heroicons_outline:sun'"></mat-icon>
        <span>Light</span>
      </button>
      <button mat-menu-item (click)="setScheme('dark')">
        <mat-icon [svgIcon]="'heroicons_outline:moon'"></mat-icon>
        <span>Dark</span>
      </button>
      <button mat-menu-item (click)="setScheme('auto')">
        <mat-icon [svgIcon]="'heroicons_outline:computer-desktop'"></mat-icon>
        <span>System</span>
      </button>
    </mat-menu>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 app-background">
  <!-- Content Card -->
  <div
    class="flex flex-col flex-auto bg-white dark:bg-gray-900 rounded-none lg:rounded-[2rem] shadow-none lg:shadow-[0_4px_28px_rgba(0,0,0,0.06)] dark:lg:shadow-[0_10px_50px_rgba(0,0,0,0.3)] lg:border-0 dark:lg:border dark:border-gray-800/60 m-0 lg:m-6 overflow-hidden min-h-0 transition-all"
    [class.lg:ml-0]="isNavigationOpened">
    <!-- Header inside card -->
    <div
      class="relative flex items-center justify-between shrink-0 h-14 sm:h-16 px-4 sm:px-6 md:px-8 border-b border-gray-100 dark:border-gray-800">
      <!-- Toggle menu (Visible on mobile, or when nav is closed on desktop) -->
      <button class="-ml-2 text-gray-600 dark:text-gray-400 shrink-0 transition-opacity" 
        [class.hidden]="!isScreenSmall && isNavigationOpened"
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')">
        <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
      </button>

      <!-- Event Ticker -->
      <div class="flex flex-auto items-center overflow-hidden mx-4 h-6">
        <event-ticker class="w-full"></event-ticker>
      </div>

      <div class="flex items-center space-x-3 text-gray-500 dark:text-gray-400 shrink-0 pt-1 lg:pt-0">
        <notifications></notifications>
        <search appearance="bar"></search>
      </div>
    </div>

    <!-- Scroll area -->
    <div class="flex flex-col flex-auto overflow-y-auto bg-white dark:bg-transparent">
      <div class="flex flex-col flex-auto p-4 sm:p-6 md:p-8">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>